import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useResponsive } from 'src/hooks/use-responsive';
import { useResponsiveConfig } from '../utils/use-responsive-config';
import CompetitorModal from './competitor-modal';

interface DomainPillProps {
    domain: string;
    workspaceId?: string;
}

export default function DomainPill({ domain, workspaceId = '48' }: DomainPillProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const responsiveConfig = useResponsiveConfig();
    const { paddingX, paddingY, maxWidth, iconSize, fontSize } = responsiveConfig.domainPill;

    const handleDomainClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    
    return (
        <>
            <Box
                onClick={handleDomainClick}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: paddingX,
                    py: paddingY,
                    borderRadius: '16px',
                    backgroundColor: (theme) => "rgba(145, 158, 171, 0.1)",
                    color: 'primary.contrastText',
                    maxWidth: `${maxWidth}px`,
                    cursor: 'pointer',
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                }}
            >
            <Box
                component="img"
                src={`https://www.google.com/s2/favicons?domain=${domain}&sz=16`}
                sx={{ width: iconSize, height: iconSize, backgroundColor: '#fff', borderRadius: '50%' }}
                alt={domain}
            />
                <Typography
                    variant="caption"
                    sx={{
                        fontWeight: 'medium',
                        fontSize: fontSize,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        color: (theme) => "rgba(51, 60, 71, 1)",
                    }}
                >
                    {domain}
                </Typography>
            </Box>

            <CompetitorModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                domain={domain}
                workspaceId={workspaceId}
            />
        </>
    );
}
